//Please add the language resource
const shipTo = {
  areaName:'AreaName',
  shiptoName:'ShiptoName',
  customerNo:'CustomerNo',
  city:'City',
  areaCode:'AreaCode',
  postcode:'Postcode',
  delStatus:'DelStatus',
  soldtoNo:'SoldtoNo',
  frozenState:'FrozenState',
  shiptoNo:'ShiptoNo',
  district:'District',
  tel:'Tel',
  fax:'Fax',
  msg:{
  }
};
export default shipTo


// WEBPACK FOOTER //
// ./src/page/md/shipTo/lang/shipTo.en.js